import { CUSTOMER_ACTIONS } from "../constants/actionsConstants";

const initialState = {
  customer_name: '',
  summary_info: [],
  basic_info: [],
  financial: {},
  orders: [],
  activities: [],
  deals: [],
  activeTab: 'General'
};

const customerReducer = (state = initialState, action) => {
  switch (action.type) {
    case CUSTOMER_ACTIONS.SET_CUSTOMER_INFO:
      return {
        ...state,
        customer_name: action.data.customer_name,
        summary_info: action.data.summary_info,
        basic_info: action.data.basic_info,
        financial: action.data.financial,
        orders: action.data.orders,
        activities: action.data.activities,
        deals: action.data.deals
      };
    case CUSTOMER_ACTIONS.SET_ACTIVE_TAB:
      return {
        ...state,
        activeTab: action.data
      };
    default:
      return state;
  }
};

export default customerReducer;
